"use strict";
/**
 *  @module Resources/Verification
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Verification = void 0;
var tslib_1 = require("tslib");
var RestAPI_js_1 = require("../api/RestAPI.js");
var CRUDResource_js_1 = require("./CRUDResource.js");
var Verification = /** @class */ (function (_super) {
    tslib_1.__extends(Verification, _super);
    function Verification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Verification.prototype.create = function (data, auth, callback) {
        return this._createRoute(Verification.requiredParams)(data, callback, auth);
    };
    Verification.prototype.get = function (data, auth, callback) {
        return this.defineRoute(RestAPI_js_1.HTTPMethod.GET, this._routeBase)(data, callback, auth);
    };
    Verification.prototype.update = function (data, auth, callback) {
        return this.defineRoute(RestAPI_js_1.HTTPMethod.PATCH, this._routeBase)(data, callback, auth);
    };
    Verification.requiredParams = [
        "homepageUrl",
        "companyDescription",
        "companyContactInfo",
        "businessType",
        "systemManagerName",
    ];
    Verification.routeBase = "/verification";
    return Verification;
}(CRUDResource_js_1.CRUDResource));
exports.Verification = Verification;
//# sourceMappingURL=Verification.js.map